// Shared nav-active-key resolution for Nav + TabBar.
export function getActiveKey(pathname) {
  if (pathname === '/') return 'home';
  if (pathname === '/apps') return 'apps';
  if (pathname === '/studio') return 'studio';
  if (pathname === '/contact') return 'contact';
  if (
    pathname.startsWith('/app/') ||
    pathname === '/aeropace' ||
    pathname.startsWith('/aeropace/')
  ) {
    return 'apps';
  }
  return null;
}

export const HOME_PATHS = ['/', '/apps', '/studio', '/contact'];
